import { create } from "zustand";

export type VariablePriceEntry = {
  priceInCents: number;
  sku: string;
};

type VariablePriceState = {
  variablePriceItems: Record<string, VariablePriceEntry[]>;
};

type VariablePriceActions = {
  addVariablePriceEntry: (itemId: string, entry: VariablePriceEntry) => void;
  reset: () => void;
};

export type VariablePriceStore = VariablePriceState & VariablePriceActions;

const initialState: VariablePriceState = {
  variablePriceItems: {},
};

export const useVariablePriceStore = create<VariablePriceStore>()((set) => ({
  ...initialState,

  addVariablePriceEntry: (itemId, entry) =>
    set((state) => ({
      variablePriceItems: {
        ...state.variablePriceItems,
        [itemId]: [...(state.variablePriceItems[itemId] ?? []), entry],
      },
    })),

  reset: () => set(initialState),
}));
